export const isVdMartLocation = value => String(value || '').trim().toUpperCase() === 'VADAPARRU';
export const storedVdMartLocation = () => {
  try { return isVdMartLocation(JSON.parse(localStorage.getItem('posUserInfo') || '{}').location); } catch { return false; }
};
export const buyerQuery = state => {
  if (!isVdMartLocation(state.posUser?.userInfo?.location)) return '';
  const buyer = state.cart?.buyer || { stakeholderType: 'outlet', phoneNo: '' };
  const query = new URLSearchParams({ stakeholderType: buyer.stakeholderType, phoneNo: buyer.phoneNo });
  if (buyer.stakeholderId) query.set('stakeholderId', buyer.stakeholderId);
  if (buyer.billingMode) query.set('billingMode', buyer.billingMode);
  return query.toString();
};
export const withVdMartBuyer = (payload, state) => {
  if (!isVdMartLocation(state.posUser?.userInfo?.location)) return payload;
  if (!state.cart?.buyer) throw new Error('Select the buyer before creating an order.');
  return { ...payload, ...state.cart.buyer, phoneNo: payload.phoneNo ?? state.cart.buyer.phoneNo, catalogSource: 'ProductsVdMart', MK_order_id: state.cart.buyer.orderId };
};

export const storedBuyer = () => { try { return JSON.parse(localStorage.getItem('cart') || '{}').buyer; } catch { return null; } };
export const selectLocalCatalog = (products, buyer) => (products || []).map(product => {
  if (product.catalogSource !== 'ProductsVdMart') return product;
  const type = buyer?.billingMode === 'retail' ? 'outlet' : buyer?.stakeholderType || 'outlet';
  return { ...product, details: product.details.map(detail => ({ ...detail, financials: detail.financials.map(financial => {
    const rates = financial.stakeholderFinancials || [];
    const rate = (buyer?.billingMode !== 'retail' && rates.find(rate => rate.type === type && rate.stakeholderId != null && String(rate.stakeholderId) === String(buyer?.stakeholderId))) || rates.find(rate => rate.type === type && rate.stakeholderId == null);
    return rate ? { ...financial, price: rate.price, dprice: rate.dprice, Discount: rate.Discount } : null;
  }).filter(Boolean) })).filter(detail => detail.financials.length) };
}).filter(product => product.details?.length);

export const lookupLocalVdMartProduct = (products, code) => {
  const normalize = value => String(value ?? '').trim().replace(/^0+/, '');
  for (const product of products || []) for (const detail of product.details || []) for (const financial of detail.financials || []) {
    const codes = [financial.mkid, financial.product_barcode_id, financial.catalogProductBarcodeId, financial.mk_barcode, ...(Array.isArray(financial.barcode) ? financial.barcode : [financial.barcode])];
    if (!codes.some(value => value != null && normalize(value) === normalize(code))) continue;
    return { ...financial, id: product._id, productName: product.name, brandId: detail._id, brand: detail.brand,
      financialId: financial._id, MRP: financial.price, catalogQuantity: financial.quantity, image: detail.images?.[0]?.image || '', discount: financial.Discount };
  }
  throw new Error('Barcode not in the local catalog for this stakeholder. Use Refresh to reload products and financials.');
};

// The stable POS route selects the Mongo collection using the authenticated outlet.
export const posCatalogPath = () => 'pos-products/catalog';
export const validateVdMartCatalog = (products, location) => {
  const invalid = products.some(product => product.catalogSource !== 'ProductsVdMart' ||
    product.details?.some(detail => detail.financials?.some(financial => !Array.isArray(financial.stakeholderFinancials))));
  if (isVdMartLocation(location) && invalid) {
    throw new Error('ProductsVdMart financials are missing. Update the backend and refresh the catalog.');
  }
  return products;
};
